if(!customElements.get('sub-collection')){
    class SubCollection extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback(){
            const spaceBetween = this.dataset.space || 8;
            this.swiper = new Swiper(
                this.querySelector('.swiper'), {
                    spaceBetween,
                    slidesPerView: 'auto',
                    freeMode: true,
                }
            )
        }
    }
    customElements.define('sub-collection',SubCollection );
}